import { gsap, ScrollTrigger } from 'gsap/all';
import Lenis from 'lenis';

gsap.registerPlugin(ScrollTrigger);

export default function setupLenis() {
  const lenis = new Lenis({
    smooth: true,
    easing: (t) => t * (2 - t),
    smoothTouch: true,
    lerp: 0.1
  });

  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);

  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
  }

  const cleanUrl = window.location.origin + window.location.pathname;
  if (window.location.href !== cleanUrl) {
    window.history.replaceState({}, document.title, cleanUrl);
  }

  requestAnimationFrame(() => {
    lenis.scrollTo(0, { immediate: true });
  });

  const resetScroll = () => {
    lenis.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
    setTimeout(() => lenis.scrollTo(0, { immediate: true }), 50);
  };

  window.addEventListener('load', resetScroll);
  window.addEventListener('beforeunload', resetScroll);
  
  const scrollToHash = async (hash) => {
    if (!hash) return;
    const targetElement = document.getElementById(hash);
    if (!targetElement) return;

    await lenis.scrollTo(targetElement, {
      duration: 1,
      easing: (t) => 1 - (1 - t) ** 3,
      onComplete: () => {
        setTimeout(() => {
          ScrollTrigger.refresh();
          ScrollTrigger.update();
        }, 100);
      }
    });

    window.history.replaceState(null, null, `#${hash}`);
  };

  const anchorScroll = () => {
    document.querySelectorAll('a[href^="/#"], a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', (e) => {
        e.preventDefault();
        const href = anchor.getAttribute('href');
        const targetId = href.includes('#') ? href.split('#')[1] : null;
        if (!targetId) return;

        const isSamePage = href.startsWith('#') || href.startsWith(`${window.location.pathname}#`);
        if (isSamePage) setTimeout(() => scrollToHash(targetId), 250);
        else window.location.href = `/#${targetId}`;
        anchor.blur();
      });
    });
  };

  anchorScroll();

  if (window.location.hash) {
    const hash = window.location.hash.replace('#', '');
    setTimeout(() => scrollToHash(hash), 50);
  }
}
